import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

const formatCurrency = (value: number | null | undefined) => {
  if (value === null || value === undefined) return "";
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

type Props = {
  onActionEditar: (Id: number | null, openState: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
};

export const GenerateEntradaProdutosColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "Data",
      filterable: false,
      headerName: "Data Entrada",
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (<span className="w-full h-full flex justify-center items-center text-center text-xs py-2">{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: "NomeCentroCusto",
      filterable: false,
      headerName: "Centro Custo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Codigo",
      width: 80,
      minWidth: 80,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 break-normal">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NrNotaFiscal",
      filterable: false,
      headerName: "Nº NF",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NroOrdemCompra",
      filterable: false,
      headerName: "Nº OC",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      headerName: "Quantidade",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      headerName: "Valor Unitário",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (<span className="w-full h-full flex justify-center items-center text-center text-xs py-2">{formatCurrency(params.value)}</span>);
      },
    },
    {
      field: "ValorTotal",
      filterable: false,
      headerName: "Valor Total",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (<span className="w-full h-full flex justify-center items-center text-center text-xs py-2">{formatCurrency(params.value)}</span>);
      },
    },
    {
      field: "NomeFornecedor",
      filterable: false,
      headerName: "Fornecedor",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: 'IdEntradaProduto',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-1">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
            </IconButton>
            <IconButton onClick={() => onActionDeletar(params.value, true)} >
              <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}